import { memo, useState } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@volca/ui/components/ui/toggle-group";
import { cn } from "@volca/ui/lib/utils";
import { IcmPieChart, IcmPieChartEntry } from "./icm-pie-chart";

export interface IcmPieTab {
  label: string;
  data: IcmPieChartEntry[];
}

interface IcmTabbedPieChartProps {
  tabs: IcmPieTab[];
  className?: string;
}

export const IcmTabbedPieChart = memo(
  ({ tabs, className }: IcmTabbedPieChartProps) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const activeData = tabs[activeIndex]?.data ?? [];

    if (tabs.every((t) => t.data.length === 0)) return null;

    return (
      <Stack
        align="start"
        gap={2}
        className={cn("w-full max-w-[500px] min-w-0", className)}
      >
        {tabs.length > 1 && (
          <Stack direction="row" justify="end" align="center" gap={4}>
            <ToggleGroup
              size="sm"
              aria-label="Chart"
              value={[String(activeIndex)]}
              onValueChange={(value) => {
                if (value.length) setActiveIndex(Number(value[0]));
              }}
            >
              {tabs.map(({ label }, i) => (
                <ToggleGroupItem key={label} value={String(i)}>
                  {label}
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </Stack>
        )}
        <IcmPieChart data={activeData} />
      </Stack>
    );
  },
);
